// eslint-disable-next-line @typescript-eslint/ban-types
export function pickObjectProperty<T extends Object, K extends keyof T>(obj: T, keys: K[])
  : Pick<T, K> {
  const result = {} as Record<K, unknown>;

  keys.forEach((key) => {
    result[key] = obj[key];
  });

  return result as Pick<T, K>;
}
